import { Link } from "react-router-dom"
import { ThemeToggle } from "@/components/ui/ThemeToggle"
import { LanguageSelector } from "@/components/ui/LanguageSelector"
import { Button } from "@/components/ui/Button"
import { Logo } from "@/components/ui/Logo"
import { useTranslation } from "react-i18next"

export function LandingHeader() {
  const { t } = useTranslation('landing')

  return (
    <header className="sticky top-0 z-50 w-full glass border-b border-white/20 dark:border-white/10">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center space-x-2">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center space-x-8">
          <Link 
            to="#features" 
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-gradient-to-r after:from-emerald-500 after:to-purple-500 hover:after:w-full after:transition-all"
          >
            {t('nav.features')}
          </Link>
          <Link 
            to="#templates" 
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-gradient-to-r after:from-emerald-500 after:to-purple-500 hover:after:w-full after:transition-all"
          >
            {t('nav.templates')}
          </Link>
          <Link 
            to="#how-it-works" 
            className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-gradient-to-r after:from-emerald-500 after:to-purple-500 hover:after:w-full after:transition-all"
          >
            {t('nav.howItWorks')}
          </Link>
        </nav>

        <div className="flex items-center space-x-4">
          <LanguageSelector />
          <ThemeToggle />
          <Link to="/login">
            <Button 
              variant="ghost"
              className="hover:bg-white/10 dark:hover:bg-white/5 transition-colors"
            >
              {t('nav.login')}
            </Button>
          </Link>
          <Link to="/register">
            <Button 
              className="bg-gradient-to-r from-emerald-500 to-purple-500 hover:from-emerald-600 hover:to-purple-600 hover:scale-105 transition-all duration-300 shadow-md text-white"
            >
              {t('nav.getStarted')}
            </Button>
          </Link>
        </div>
      </div>
    </header>
  )
}
